import queryKeys from '@/constants/query-keys';
import { useQuery } from '@tanstack/react-query';
import { ApiBackendInfo, AthenaMenuSetting } from './types';
import { useApiBackendInfo } from '..';
import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';


export const fetchAthenaMenuSetting = async (apiBackendInfo: ApiBackendInfo): Promise<ApiResponse<AthenaMenuSetting>> => {
	const response = await fetchComposer.getWithBearer(`${apiBackendInfo.url}/Athena/GetAthenaMenuSetting`)(apiBackendInfo.token ?? '');
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

export const useAthenaMenuSetting = () => {
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const apiBackendInfo = useApiBackendInfo();
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.ATHENA_MENU_SETTING, apiBackendInfo.url, apiBackendInfo.token],
		queryFn: () => fetchAthenaMenuSetting(apiBackendInfo),
		refetchOnWindowFocus: false,
		staleTime: 1000 * 30,
		cacheTime: 1000 * 60,
		enabled: isAthena && apiBackendInfo.isReady
	});

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch
	};
};